import { createSlice } from '@reduxjs/toolkit';

const subjectsV2Slice = createSlice({
  name: 'delta/subjectsV2',
  initialState: [],
  reducers: {
    resetSubjectsV2: () => [],
    getSubjectsV2: (state, action) => action.payload,
  },
});

export const { getSubjectsV2, resetSubjectsV2 } = subjectsV2Slice.actions;

export default subjectsV2Slice.reducer;
